import { CircularProgress, Dialog } from '@material-ui/core';
import React from 'react';
export const Loading=({open})=>{
  return (
    <Dialog open={open}>
        <div style={{width:60,height:60,paddingTop:10,display:'flex',justifyContent:'center'}}>
          <CircularProgress disableShrink/>
        </div>
    </Dialog>
  );
}